<h1 *ngIf="showMessage">Sorry no access detected. Please log in.</h1>